<template>
  <el-row>
    <el-col>
      <el-col v-if="!disabled" class="top-right">
        <el-input
          v-model="queryForm.contractName"
          class="top-search"
          placeholder="合同名称"
        >
          <el-button
            slot="append"
            type="primary"
            icon="el-icon-search"
            @click="initRelationLsit"
          />
        </el-input>
      </el-col>
      <el-form
        ref="dialogForm"
        :model="form"
        :rules="rules"
        label-position="top"
        class="dialog-form"
      >
        <el-form-item label="选择合同" required />

        <card-template
          ref="cardTemplate"
          :data="relationOption"
          :multiple="false"
          :disabled="disabled"
          @choose="chooseIte"
        />
        <el-form-item label="结算类型">
          <el-radio-group v-model="form.type" :disabled="true">
            <el-radio label="LWJS">
              分包结算
            </el-radio>
            <el-radio label="ZLJS">
              租赁结算
            </el-radio>
            <el-radio label="CLJS">
              材料结算
            </el-radio>
            <el-radio label="QTJS">
              其他结算
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.submitStatus"
          style="position:relative"
          label="结算审批状态"
        >
          <span
            class="status-box"
            :class="statusClass">{{ form.submitStatus | replyStatus }}</span>
        </el-form-item>
        <el-row>
          <el-col class="tips-box">
            <div class="tips">
              （请注意上传的发票完整、清晰、无遮挡。）
            </div>
            <el-form-item label="发票附件" required prop="settlementInvoiceList">
              <el-upload
                v-if="!disabled"
                name="files"
                action="/"
                :on-preview="invoicePreview"
                :before-upload="beforUploadInvo"
                :show-file-list="false"
                :on-change="handleInvoChange"
                :auto-upload="false"
              >
                <el-button type="info">
                  <i class="iconfont icon_shangchuan"></i>
                  上传附件
                </el-button>
                <span class="pl-18 upload-label">
                  支持扩展名png/jpg/jpeg
                </span>
              </el-upload>
              <div
                v-if="!disabled && previewInvoFile.length > 0"
                class="img-box"
              >
                <div
                  v-for="(item, index) in previewInvoFile"
                  :key="index"
                  v-loading="loadingArr[index]"
                  class="img-list img-container"
                  style="margin-bottom: 90px;"
                >
                  <el-image
                    :src="item.img"
                    :preview-src-list="filerImgList(previewInvoFile)"
                    @load="loaded(index)"
                  />
                  <div class="img-status-box">
                    <span v-if="item.status===1" class="el-icon-success"></span>
                    <span
                      v-if="item.status===2&&!disabled"
                      class="el-icon-warning"
                      @click="showErrorByInvo(index)"
                    ></span>
                    <span v-if="item.status===2&&disabled" class="el-icon-error"></span>
                  </div>
                  <el-tooltip class="file-name-box" effect="dark" :content="item.fileName" placement="center">
                    <span>{{item.fileName}}</span>
                  </el-tooltip>   
                  <br />
                  <el-button
                    v-if="!loadingArr[index]"
                    type="danger"
                    size="mini"
                    @click="deleteInvoImg(index, item)"
                  >
                    删除
                  </el-button>
                </div>
              </div>
              <el-col v-if="disabled" class="img-box">
                <div
                  v-for="(item, index) in previewInvoFile"
                  :key="index"
                  v-loading="loadingArr[index]"
                  class="img-list img-container"
                >
                  <el-image
                    :src="item.img"
                    :preview-src-list="filerImgList(previewInvoFile)"
                    @load="loaded(index)"
                  />
                  <div class="img-status-box">
                    <span v-if="item.status===2" class="el-icon-error"></span>
                  </div>
                </div>
              </el-col>
              <p class="align-center" v-if="showAnnStep&&!formData">
                <span>
                  正在上传...（{{annLoadStr}}）
                </span>
              </p>
            </el-form-item>
            <!--手动核验发票列表-->
            <ImgList v-if="imgListData.length>0" :contracts="contracts" :data="imgListData" @success="verificaItem" ref="imgList" />
          </el-col>
          <el-col class="tips-box">
            <div class="tips">
              （请注意上传的表单完整、清晰、无遮挡。）
            </div>
            <el-form-item label="结算确认单">
              <el-upload
                v-if="!disabled"
                name="files"
                :action="$global.filePath"
                ref="confirme"
                :on-preview="confirmePreview"
                :before-upload="beforUploadConfirme"
                :show-file-list="false"
                :on-change="handleConfirmeChange"
                :auto-upload="false"
              >
              
                <el-button type="info">
                  <i class="iconfont icon_shangchuan"></i>
                  上传附件
                </el-button>
                <span class="pl-18 upload-label">
                  支持扩展名png/jpg/jpeg
                </span>
              </el-upload>
             
              <div
                v-if="!disabled && previewConfirmeFile.length > 0"
                class="img-box"
              >
                <div
                  v-for="(item, index) in previewConfirmeFile"
                  :key="index"
                  v-loading="confirmedLoadingArr[index]"
                  class="img-list img-container"
                  style="margin-bottom: 90px;"
                >
                  <el-image
                    :src="item.img"
                    :preview-src-list="filerImgList(previewConfirmeFile)"
                    @load="comfirmeLoaded(index)"
                  />
                  <div class="img-status-box">
                    <span v-if="item.status===1" class="el-icon-success"></span>
                    <span
                      v-if="item.status===2&&!disabled" class="el-icon-warning"
                      @click.native="showErrorByConfirme(item)"></span>
                    <span v-if="item.status===2&&disabled" class="el-icon-error"></span>
                  </div>
                  <el-button
                    v-if="!confirmedLoadingArr[index]"
                    type="danger"
                    size="mini"
                    @click="deleteConfirImg(index)"
                  >
                    删除
                  </el-button>
                </div>
              </div>
              <el-col v-if="disabled" class="img-box">
                <div
                  v-for="(item, index) in previewConfirmeFile"
                  :key="index"
                  v-loading="confirmedLoadingArr[index]"
                  class="img-container img-list"
                >
                  <el-image
                    :src="item.img"
                    :preview-src-list="filerImgList(previewConfirmeFile)"
                    @load="comfirmeLoaded(index)"
                  />
                  <div class="img-status-box">
                    <span v-if="item.status===2" class="el-icon-error"></span>
                  </div>
                </div>
              </el-col>
              <p class="align-center" v-if="showConfirmedStep&&!formData">
                <span>
                  正在上传...（{{conLoadStr}}）
                </span>
              </p>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备注">
              <el-input
                v-model="form.remark"
                placeholder="请输入备注"
                type="textarea"
                resize="none"
                rows="6"
                maxlength="200"
                show-word-limit
                :disabled="disabled"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 审批日志 -->
        <el-row v-if="formData && formData.submitStatus > 0">
          <h3>审批日志</h3>
          <p>
            <span>审批ID：</span>
            <span class="pr-15">{{ form.syncResultId }}</span>
          </p>
          <el-col
            v-for="(item, index) in replyList"
            :key="index"
            class="info-list"
          >
            <p class="top">
              <span>{{ item.replyTime }}</span>
              <span class="pl-30">状态：</span>
              <span>{{ item.status | replyStatus }}</span>
            </p>
            <p>
              <span>审批意见：</span>
              <span>{{ item.comment }}</span>
            </p>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
    <el-col class="align-right">
      <el-button v-if="!disabled" type="warning" @click="save(1)">
        保存
      </el-button>
      <!-- <el-button v-if="!disabled" type="primary" @click="save(2)">
        提交
      </el-button> -->
      <el-button type="info" @click="close">
        取消
      </el-button>
    </el-col>
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      title="图片预览"
      append-to-body
      @close="imgDialogClose"
    >
      <img width="100%" :src="dialogImg" />
    </el-dialog>
  </el-row>
</template>

<script>
import relaAPI from '@/http/merchant/relation'
import api from '@/http/merchant/submit'
import ImgList from './ImgList'
import imgMixins from '@/components/Mixins/ImgMixins'
import CardTemplate from '../../modules/CardTemplate'
import {compress, compressAccurately} from 'image-conversion'

export default {
  components: { CardTemplate, ImgList },
  mixins: [imgMixins],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      loadingArr: [],
      confirmedLoadingArr: [],
      imgListData: [], // 核验列表
      conLoadStr: '',
      annLoadStr: '',
      showConfirmedStep: false,
      showAnnStep: false,
      showForm: false,
      dialogVisible: false,
      dialogImg: '',
      domainUserCode: '',
      contracts: [],
      colOpt: {
        span: 8,
        offset: 4
      },
      queryForm: {},
      rules: {
        settlementInvoiceList: [
          { required: true, message: '请上传发票附件', trigger: 'change' }
        ],
        settlementAnnexes: [
          { required: true, message: '请上传结算确认单', trigger: 'change' }
        ]
      },
      chooseList: {},
      previewInvoFile: [],
      previewConfirmeFile: [],
      invoFileList: [],
      confirmedFileList: [],
      relationOption: [],
      relaMap: {},
      headers: {},
      form: {
        settlementSubmitContracts: [],
        settlementAnnexes: [], // 确认单 
        settlementInvoiceList: [],// 发票
        invoiceAnnex: '',
        type: '',
        remark: ''
      },
      replyList: []
    }
  },
  created() {
    this.initRelationLsit()
  },
  mounted() {
    if (this.formData) {
      this.initForm()
      this.initReplyList()
    }
  },
  methods: {
    initForm() {
      this.form = this.formData
      this.contracts = this.form.settlementSubmitContracts
      const self = this
      if (this.form.settlementInvoiceList) {
        const ids = this.form.settlementInvoiceList
        ids.forEach((item, index) => {
          self.$set(self.previewInvoFile, index, {
            img: ''
          })
          self.$set(self.invoFileList, index, {
            img: ''
          })
          self.$set(self.loadingArr, index, true)
          self.getImg(item.id, (img, fileName) => {
            self.$set(self.invoFileList, index,  {
              img,
              fileName,
              ...item
            })
            self.$set(self.previewInvoFile, index, {
              img,
              fileName,
              ...item
            })
          })
        })
      }
      //如果为查看，则可选合同只显示已选择的列表
      if (this.disabled) {
        this.relationOption = this.form.settlementSubmitContracts
        this.relationOption.forEach(item => {
          this.$set(item, 'choose', true)
        })
      }
      if (this.form.settlementAnnexes) {
        const ids = this.form.settlementAnnexes
        this.formData.settlementSubmitContracts.forEach(item => {
          // this.chooseList[item.id] = item
          this.$set(this.chooseList, item.contractCode, item)
        })
        ids.forEach((item, index) => {
          self.$set(self.previewConfirmeFile, index,  {
            img: ''
          })
          self.$set(self.confirmedLoadingArr, index, true)
          self.getImg(item.id, img => {
            self.$set(self.previewConfirmeFile, index,  {
              img,
              ...item
            })
            self.$set(self.confirmedFileList, index,  {
              img,
              ...item
            })
          })
        })
      }
      this.$forceUpdate()
      this.showForm = true
    },
    filerImgList(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.img)
      })
      return arr
    },
    initReplyList() {
      api.getReplyList(this.formData.id).then(res => {
        if (res.code === this.sucCode) {
          this.replyList = res.data
        }
      })
    },
    loaded(index) {
      this.$set(this.loadingArr, index, false)
    },
    // 关闭加载Loading
    comfirmeLoaded(index) {
      this.$set(this.confirmedLoadingArr, index, false)
    },
    initRelationLsit() {
      relaAPI.getOwnList(this.queryForm).then(res => {
        if (res.code === this.sucCode) {
          this.relationOption = res.data
          if (this.relationOption.length > 0) {
            this.relationOption.forEach(item => {
              this.$set(item, 'choose', false)
            })
            if (this.formData) {
              this.initRelationState()
            }
          }
          this.showForm = true
        }
      })
    },
    initRelationState() {
      const arr = []
      if (this.formData.settlementSubmitContracts.length > 0) {
        this.relationOption.forEach(item => {
          this.form.settlementSubmitContracts.forEach(ite => {
            if (ite.contractCode === item.contractCode) {
              item.choose = true
              arr.push(item)
            }
          })
        })
        if (this.disabled) {
          this.relationOption = arr
        }
      }
    },
    handleCloseMini(item) {
      this.$refs.cardTemplate.map[item.contractCode].choose = false
      delete this.chooseList[item.contractCode]
      this.$forceUpdate()
    },
    chooseIte(item) {
      // 如果是选中
      this.chooseList = {}
      if (item.choose) {
        this.chooseList[item.contractCode] = item
        this.form.type = item.contractType
        // 获取当前合同的token
        this.dataGroupOrgId = item.dataGroupOrgId
      } else {
        // 如果是取消选中
        delete this.chooseList[item.contractCode]
        this.form.contractId = ''
        this.form.projectId = ''
        this.form.contractMoney = ''
        this.dataGroupOrgId = ''
      }
      const keys = Object.keys(this.chooseList).length
      if (keys === 0) {
        this.form.type = ''
      }
      this.$forceUpdate()
    },
    imgDialogClose() {
      this.dialogImg = ''
      this.dialogVisible = false
    },
    // 发票附件
    invoicePreview(file) {
      this.dialogImg = file.url
      this.dialogVisible = true
    },
    handleInvoChange(file, fileList) {
      const fileName = file.name
      const before = this.beforUploadInvo(file)
      if (before.tag) {
        const is500Kb = file.size > 512000
        if (is500Kb) {
          compressAccurately(file.raw,450).then(res=>{
            let newFile = new File([res], fileName)
            this.uploadFile(newFile).then(response => {
              // 上传成功
              this.invoiceSuccess(response, before.index)
            })
      　　})
        } else {
          this.uploadFile(file.raw).then(response => {
              // 上传成功
              this.invoiceSuccess(response, before.index)
          })
        }
      }
    },
    beforUploadInvo(file) {
      let tag = false
      const arr = ['image/jpeg', 'image/png', 'image/jpg']
      
      const isImage = arr.includes(file.raw.type)
      const isLt500Kb = true
      if (!isImage) {
        this.$message.error('请上传正确格式的图片！')
      }

      tag = isImage && isLt500Kb
      const obj = {
        tag,
        index: this.loadingArr.length
      }
      if (tag) {
        this.$set(this.loadingArr, this.loadingArr.length, true)
        this.$set(this.previewInvoFile, this.previewInvoFile.length, '')
      }
      return obj

    },
    // 发票上传成功
    invoiceSuccess(response, index) {
       if (response.code === this.sucCode) {
        this.$message.success('上传成功')
        this.$set(this.loadingArr, index, false)
        this.invoFileList.push({
          id: response.data.id,
          entityId: "",
          errorMsg: "",
          status: 0
        })
        this.form.settlementInvoiceList = this.deepCopy(this.invoFileList)      
        this.$set(
          this.previewInvoFile,
          index,
          {
            img: response.data.url
          }
        )
        this.$forceUpdate()
      } else {
        this.$message.error(response.msg)
      }

    },
    // 发票移除
    invoiceRemove(file) {
      const id = file.response.data[0].id
      const index = this.invoFileList.indexOf(id)
      this.invoFileList.splice(index, 1)
      this.loadingArr.splice(index, 1)
      this.invoFileList.length > 0
        ? (this.form.settlementInvoiceList = this.deepCopy(invoFileList))
        : (this.form.settlementInvoiceList = null)
    },

    deleteInvoImg(index, item) {
      this.$confirm('此操作将删除发票附件该项数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.invoFileList.splice(index, 1)
          this.previewInvoFile.splice(index, 1)
          this.loadingArr.splice(index, 1)
          for(let i = 0; i< this.imgListData.length; i++) {
            if (this.imgListData[i].id === item.id) {
              this.imgListData.splice(i, 1)
              return
            }
          }
          this.invoFileList.length > 0
            ? (this.form.settlementInvoiceList = this.deepCopy(this.invoFileList))
            : (this.form.settlementInvoiceList = null)

        })
        .catch(() => {
          this.$message.info('已取消！')
        })
    },
    beforUploadConfirme(file) {
      let tag = false
      const arr = ['image/jpeg', 'image/png', 'image/jpg']
      const isImage = arr.includes(file.raw.type)
      // const isLt500Kb = file.size / 1024 < 500
      if (!isImage) {
        this.$message.error('请上传正确格式的图片！')
      }
      tag = isImage
      const obj = {
        tag,
        index: this.confirmedLoadingArr.length
      }
      if (tag) {
        this.$set(
          this.confirmedLoadingArr,
          this.confirmedLoadingArr.length,
          true
        )
        this.$set(this.previewConfirmeFile, this.previewConfirmeFile.length, '')
      }
      return obj
    },
    // 结算确认单
    confirmePreview(file) {
      this.dialogImg = file.url
      this.dialogVisible = true
    },
    handleConfirmeChange(file, fileList) {
      const fileName = file.name
      const before = this.beforUploadConfirme(file)
      if (before.tag) {
        const is500Kb = file.size > 512000
        if (is500Kb) {
          compressAccurately(file.raw, 450).then(res=>{
            let newFile = new File([res], fileName)
            this.uploadFile(newFile).then(response => {
              // 上传成功
              this.confirmeSuccess(response, before.index)
            })
      　　})
        } else {
          this.uploadFile(file.raw).then(response => {
              // 上传成功
              this.confirmeSuccess(response, before.index)
          })
        }
      }
    },
    confirmeSuccess(response, index) {
      if (response.code === this.sucCode) {
        this.$message.success('上传成功')
        this.confirmedFileList.push({
          errorMsg: "",
          id: response.data.id,
          result: {},
          status: 0
        })
        this.form.settlementAnnexes = this.deepCopy(this.confirmedFileList)
        this.$set(
          this.previewConfirmeFile,
          index,
          {
            img: response.data.url
          }
        )
      } else {
        this.$message.error(response.msg)
      }

    },
    deleteConfirImg(index) {
      this.$confirm('此操作将删除结算确认单该项数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.confirmedFileList.splice(index, 1)
          this.previewConfirmeFile.splice(index, 1)
          this.confirmedLoadingArr.splice(index, 1)
          this.confirmedFileList.length > 0
            ? (this.form.syncCheckAnnexIds = this.confirmedFileList)
            : (this.form.syncCheckAnnexIds = null)
        })
        .catch(() => {
          this.$message.info('已取消！')
        })
    },
    uploadFile(file) {
      return new Promise((resolve, reject) => {
        const fd = new FormData()
        // 添加图片文件
        fd.append('file', file)
        this.$axios({
          url: '/prod-api/file/upload',
          method: 'POST',
          data: fd,
          headers: { "Content-Type": "multipart/form-data" }
        }).then(fileRes => {
          if (fileRes.data && fileRes.data.code === 200) {
            const data = fileRes.data
            resolve(data) 
          }
        })
      })
    },
    save() {
      const keys = Object.keys(this.chooseList)
      if (keys.length < 1) {
        this.$message.warning('请选择合同！')
        return
      }
      this.form.settlementSubmitContracts = []
      for (const key in this.chooseList) {
        const obj = { ...this.chooseList[key] }
        delete obj.id
        this.form.settlementSubmitContracts.push(obj)
      }
      this.$refs['dialogForm'].validate(valid => {
        if (valid) {
          // 验证通过
          if (this.formData) {
            this.doUpdate()
          } else {
            this.$loading()
            this.doSave()
          }
          // this.doSubmit()
        } else {
          this.$message.warning('请填写完整!')
          return false
        }
      })
    },
    doSave() {
      api.saveData(this.form).then(
        res => {
          this.$loading().close()
          if (res.code === this.sucCode) {
            this.$message.success('保存成功')
            this.$emit('close', 1)
          } else {
            this.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              type: 'error'
            })
          }
        },
        () => {
          this.$message.error('提交失败，请稍后重试！')
          this.$loading().close()
        }
      )
    },
    doUpdate() {
      this.$confirm('此操作将修改此项数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$loading()
          api.updateData(this.form).then(
            res => {
              this.$loading().close()
              if (res.code === this.sucCode) {
                this.$message.success('修改成功')
                this.$emit('close', 1)
              } else {
                this.$alert(res.msg, '提示', {
                  confirmButtonText: '确定',
                  type: 'error'
                })
              }
            },
            () => {
              this.$message.error('修改失败，请稍后重试！')
              this.$loading().close()
            }
          )
        })
        .catch(() => {
          this.$message.info('已取消！')
        })
    },
    verificaItem(obj) {
      this.invoFileList.forEach(item =>{
        if (item.attachmentUrl === obj.attachmentUrl) {
          item.result = obj.result
          item.status = 1
          item.errorMsg = ''
        }
      })
      this.form.settlementInvoiceList.forEach((item, index) => {
        if (item.attachmentUrl === obj.attachmentUrl) {
          item.result = obj.result
          item.status = 1
          item.errorMsg = ''
        }
      })
      this.toUpdate()
    },
    toUpdate() {
      api.updateData(this.form).then(
        res => {
          this.$loading().close()
          if (res.code === this.sucCode) {
            this.$message.success('修改成功')
          } else {
            this.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              type: 'error'
            })
          }
        },
        () => {
          this.$message.error('修改失败，请稍后重试！')
          this.$loading().close()
        }
      )
    },
    // 显示
    showErrorByInvo(index) {
      const item = this.previewInvoFile[index]
      if (!item.isChoose) {
        let str = `<p>发票提交失败</p>`
        str += `失败原因：<strong>${item.errorMsg}</strong>`
        str += '<p>请根据实际情况选择重新上传或<span>去手动核验</span></p>'
        this.$confirm(str, '提示', {
          confirmButtonText: '去核验',
          cancelButtonText: '关闭',
          dangerouslyUseHTMLString: true,
          type: 'error'
        }).then(() => {
          item.isChoose = true
          this.imgListData.push(item)
          this.$forceUpdate()
          this.$nextTick(() => {
            let el = document.getElementsByClassName('el-dialog__wrapper')[0]
            let invoList = document.getElementById('invoList')
            let top = invoList.offsetTop
            el.scrollTop += top
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      } else {
        this.$message.info('您已选择，请手动核验！')
      }
    },
    showErrorByConfirme(item) {
      this.$confirm(item.errorMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        dangerouslyUseHTMLString: true,
        type: 'error'
      }).then(() => {
      }).catch(() => {
      })
    },
    close() {
      this.$emit('close')
    }
  },
  watch: {
    confirmedLoadingArr(newVal, oVal) {
      let num = 0
      const self = this
      this.confirmedLoadingArr.forEach(item => {
        if (!item) {
          num ++
        }
      })
      if (this.confirmedLoadingArr.includes(true)) {
        this.showConfirmedStep = true
      } else {
        setTimeout(() => {
          self.showConfirmedStep = false
        }, 1500)
      }
      this.conLoadStr = `${num} / ${this.confirmedLoadingArr.length}`
    },
    loadingArr() {
      let num = 0
      const self = this
      this.loadingArr.forEach(item => {
        if (!item) {
          num ++
        }
      })
      if (this.loadingArr.includes(true)) {
        this.showAnnStep = true
      } else {
        setTimeout(() => {
          self.showAnnStep = false
        }, 1500)
      }
      this.annLoadStr = `${num} / ${this.loadingArr.length}`
    }
  },
  filters: {
    steps(data) {
      let num = 0
      data.forEach(item => {})
    }
  },
  computed: {
    statusClass() {
      let className = ''
      if (this.formData) {
        switch (this.formData.submitStatus) {
          case 0:
            className = 'status-0'
            break
          case 3:
            className = 'status-0'
            break
          case 7:
            className = 'status-0'
            break
        }
      }
      return className
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-box {
  position: relative;
  .tips {
    position: absolute;
    left: 5.625rem;
    color: #ef5356;
    line-height: 40px;
  }
  &::v-deep {
    .el-form-item__content {
      position: none;
    }
  }
}
.img-container {
  width: 148px;
  height: 148px;
  margin: 10px;
}
.img-box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.img-list {
  display: inline-block;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  img {
    width: 148px;
    height: 148px;
    border-radius: 6px;
    margin-right: 10px;
  }
  .img-status-box {
    position: absolute;
    top: -5px;
    right: 0;
    font-size: 1.25rem;
    .el-icon-warning {
      cursor: pointer;
      color: #EF5356;
    }
    .el-icon-error {
      color: #EF5356;
    }
    .el-icon-success {
      color: #67C23A;
    }
  }
}
.top-right {
  position: absolute;
  top: 10px;
  right: 20px;
  width: auto;
  .top-search {
    width: 220px;
  }
}
.info-list {
  p {
    position: relative;
    padding-left: 20px;
    &:first-child {
      margin-top: 0;
      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #5482f8;
        transform: translateY(-50%);
      }
    }
  }
}
.status-box {
  position: absolute;
  top: -35px;
  left: 110px;
  background: #5482F8;
  padding: 0px 20px;
  border-radius: 20px;
  color: white;
  line-height: 30px;
}
.normal-color {
  background: #5482F8;
}
.status-0 {
  background: #f6b63f;
}
.file-name-box {
  display: inline-block;
  width: 100%;
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
::v-deep {
  .el-input-group__append {
    background: $primary;
  }
  .el-image {
    width: 148px;
    height: 148px;
    border-radius: 6px;
    margin-right: 10px;
  }
}
</style>
